import React from 'react';
import _ from 'lodash';

import {connect} from 'react-redux';

import Table from 'components/Table';
import ErrorBlock from 'components/ErrorBlock';
import Warning from 'components/Warning';
import {default as Modal, withModal} from 'components/Modal';

import {
  REFETCH_AGREEMENT_DELAY,
  MODALS,
  fetchSendAgreementDetails,
  sendAgreement,
  fetchAgreement,
  fetchAgreements
} from 'ducks/bookings';
import {delayedAction, composeActions} from 'ducks/common';
import {storeDataInModal} from 'ducks/modals';

import {AgreementUserRow, Buttons} from './components';

import './styles.css';

class SendAgreementModal extends React.Component<any> {
  sendAgreement = () => {
    const {data: {agreementId, bookingId, warnings}} = this.props;

    /*
     First delay waits for the send signature request task to finish
     We refetch agreement detail modal to allow remind and cancel actions
    */
    const delayedExtraAction = () =>
      delayedAction({
        delay: REFETCH_AGREEMENT_DELAY,
        action: () =>
          fetchAgreement({agreementId}, [
            data => storeDataInModal({modalName: MODALS.AGREEMENT_DETAIL, data})
          ])
      });
    /*
     Second delay waits for the download contract task which is dependent on HelloSign webhook
     We need to refetch agreements table and agreement detail modal again
     because both have functionality to preview/download the contract.

     *NOTE*: The second delay must be a `success extra action` of the first one as we want to execute it after the first one is finished
    */
    const secondDelayedExtraAction = () =>
      delayedAction({
        delay: REFETCH_AGREEMENT_DELAY * 2,
        action: () =>
          composeActions([
            () => fetchAgreements({bookingId}),
            () =>
              fetchAgreement({agreementId}, [
                data =>
                  storeDataInModal({modalName: MODALS.AGREEMENT_DETAIL, data})
              ])
          ])
      });

    const successExtraActions = [
      ...this.props.storeDataExtraActions(() => ({
        submitting: false
      })),
      ...this.props.closeModalExtraActions,
      delayedExtraAction,
      secondDelayedExtraAction
    ];

    const failureExtraActions = this.props.storeDataExtraActions(
      ({errors, warnings}) => ({errors, warnings, submitting: false})
    );

    this.props.composeActions([
      ...this.props.storeDataExtraActions(() => ({
        submitting: true
      })),
      () =>
        sendAgreement(
          {bookingId, agreementId, warnings: _.get(warnings, '_meta')},
          successExtraActions,
          failureExtraActions
        )
    ]);
  };

  componentDidMount() {
    const {data: {agreementId}} = this.props;
    const fetchSendAgreementDetailsExtraActions = this.props.storeDataExtraActions(
      agreement => ({agreement})
    );

    this.props.fetchSendAgreementDetails(
      {agreementId},
      fetchSendAgreementDetailsExtraActions
    );
  }

  render() {
    const {primaryTenant, secondaryTenant, guarantor, agent} = _.get(
      this.props.data,
      'agreement',
      {}
    );
    const {submitting, errors, warnings} = this.props.data;

    return (
      <Modal
        className="SendAgreementModal"
        show={true}
        type={Modal.EXTRA_SMALL}
        onClose={this.props.closeModal}>
        <Modal.Header heading="Send Agreement" />
        <Modal.Body>
          {_.get(errors, '_error') && <ErrorBlock>{errors._error}</ErrorBlock>}
          {!_.isEmpty(warnings) && (
            <Warning>{_.get(warnings, '_warning')}</Warning>
          )}
          <div className="sendLabel">
            This will send the agreement to the following parties:
          </div>
          <Table>
            <Table.Body>
              {primaryTenant && (
                <AgreementUserRow
                  label="Primary tenant"
                  agreementUser={primaryTenant}
                />
              )}
              {secondaryTenant && (
                <AgreementUserRow
                  label="Secondary tenant"
                  agreementUser={secondaryTenant}
                />
              )}
              {guarantor && (
                <AgreementUserRow label="Guarantor" agreementUser={guarantor} />
              )}
              {agent && (
                <Table.Row>
                  <Table.Cell>Agent</Table.Cell>
                  <Table.Cell>{agent}</Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Buttons
            triggerSubmit={this.sendAgreement}
            submitButtonDisabled={submitting}
            onClose={this.props.closeModal}
            submitting={submitting}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapDispatchToProps = {
  fetchSendAgreementDetails,
  composeActions
};

export default connect(null, mapDispatchToProps)(
  withModal(MODALS.SEND_AGREEMENT)(SendAgreementModal)
);
